import '../styles/index.scss';
import data from './data.js';
import {runHamburger} from './hamburger';

const setInitialState = () => {
  data.isHome = true;
  data.activePage = 'home';
  data.activeHeaderImage = 'image0.jpeg';
};

const loadInitialPage = () => {
  const page = location.hash.replace('#','');
  if (page === '') {
    setInitialState();
  } else {
    loadPage(page);
  }
};

const setActivePage = (page) => {
  document.title = 'Rajiv & Laura - ' + page.charAt(0).toUpperCase() + page.slice(1);
  if (page == 'rsvp') {
    data.hideIframe = false; 
    document.querySelector('iframe').style.display = 'block';
  } else {
    data.hideIframe = true;
    document.querySelector('iframe').style.display = 'none';
  }
  data.activePage = page;
};

const setActiveHeaderImage = (page) => {
  for (let i = 0; i < data.links.length; i++) {
    if (data.links[i].page === page) {
      data.activeHeaderImage = data.links[i].image;
    }
  }
};

const loadPage = (page) => {
  setActivePage(page);
  setActiveHeaderImage(page);
};

const toggleActive = (event) => {
  document.querySelectorAll('.nav-main__item').forEach((el) => {
    el.classList.remove('active');
  });
  event.target.parentNode.classList.add('active');
};

var app = new Vue({
  el: '#app',
  data: data,
  mounted() {
    runHamburger();
    loadInitialPage();


    var end = new Date('10/10/2020 3:1 AM');

    var _second = 1000;
    var _minute = _second * 60;
    var _hour = _minute * 60;
    var _day = _hour * 24;
    var timer;

    function showRemaining() {
        var now = new Date();
        var distance = end - now;
        if (distance < 0) {

            clearInterval(timer);
            document.getElementById('countdown').innerHTML = 'Its Today!';

            return;
        }
        var days = Math.floor(distance / _day);
        var hours = Math.floor((distance % _day) / _hour);
        var minutes = Math.floor((distance % _hour) / _minute);
        var seconds = Math.floor((distance % _minute) / _second);

        document.getElementById('countdown').innerHTML = days + ' days to go!';
    }

    timer = setInterval(showRemaining, 1000);


  },
  methods: {
    covidUpdate: function(e) {
      this.$refs.overlay.style.display = "block";
      this.$refs.covid.style.display = "block";
    },
    closeCovidUpdate: function() {
      this.$refs.overlay.style.display = "none";
      this.$refs.covid.style.display = "none";
    },
    openPage: (event) => {
      const link = event.target.getAttribute('data-nav').replace('nav-','');
      window.scrollTo(0,0);
      toggleActive(event);
      loadPage(link);
    },
    selectActiveImage: function(event) {
      const selectedImage = event.target;
      const galleryImages = this.$refs.galleryImages.children;

      galleryImages.forEach((item) => {
        const featuredImage = item;

        if (selectedImage.getAttribute('data-id') === featuredImage.getAttribute('data-id')) {
          featuredImage.classList.add('active');
        } else {
          featuredImage.classList.remove('active');
        }
      });
    },
    paginateImages: function(event) {
      const galleryImages = document.getElementsByClassName('feature-image');
      const direction = event.target.getAttribute('data-direction');
      
      galleryImages.forEach((item, index) => {
        if (item.classList.contains('active') && direction === 'right') {
          
          if (item.nextElementSibling.nodeName === 'SPAN') {
            item.classList.remove('active');
            setTimeout(() => {
              galleryImages[0].classList.add('active');
            }, 100);            
          }

          item.classList.remove('active');
          setTimeout(() => {
            item.nextElementSibling.classList.add('active');
          }, 100);
        } else if (item.classList.contains('active') && direction === 'left') {

          if (item.previousElementSibling === null) {
            item.classList.remove('active');
            setTimeout(() => {
              galleryImages[10].classList.add('active');
            }, 100);
          } else {
            item.classList.remove('active');
            setTimeout(() => {
              item.previousElementSibling.classList.add('active');
            }, 100);
          }
        }
      });
    }
  },
});